import { startCase } from "lodash-es";
export function genericCommandFactory(config) {
  const out = {};
  for (const cmdId in config.commandDefs) {
    const def = config.commandDefs[cmdId];
    const command = { id: cmdId };
    command.execute = (...execArgs) => {
      config.handleReturn(
        cmdId,
        def.handler && def.handler.apply(command, config.getArguments(cmdId, execArgs))
      );
    };
    const properties = [
      "icon",
      "name",
      "component",
      "shortName",
      "description",
      "hotkey",
      "hotkeyProps",
      "isDisabled",
      "submenu",
      "isActive",
      "isHidden",
      "tooltip",
      "inactiveIcon",
      "inactiveName"
    ];
    properties.forEach((prop) => {
      if (def[prop] !== void 0) {
        if (typeof def[prop] === "function") {
          Object.defineProperty(command, prop, {
            get: () => {
              return def[prop].apply(command, config.getArguments(cmdId, []));
            }
          });
        } else {
          command[prop] = def[prop];
        }
      }
    });
    if (!def.name) {
      command.name = startCase(cmdId);
      if (def.toggle && cmdId.startsWith("toggle")) {
        command.name = startCase(cmdId.replace("toggle", def.toggle[0] || ""));
        command.inactiveName = startCase(
          cmdId.replace("toggle", def.toggle[1] || "")
        );
        command.shortName = startCase(cmdId.replace("toggle", ""));
      }
    }
    out[cmdId] = command;
  }
  return out;
}
export function getCommandHotkeys(commandsOrDefs) {
  const hotkeyDefs = {};
  Object.keys(commandsOrDefs).forEach((cmdId) => {
    const hotkey = commandsOrDefs[cmdId].hotkey;
    if (hotkey) {
      const combos = Array.isArray(hotkey) ? hotkey : [hotkey];
      combos.forEach((combo, i) => {
        const suffix = i === 0 ? "" : `_${i}`;
        hotkeyDefs[`${cmdId}${suffix}`] = {
          combo,
          label: commandsOrDefs[cmdId].name || startCase(cmdId),
          ...commandsOrDefs[cmdId].hotkeyProps
        };
      });
    }
  });
  return hotkeyDefs;
}
export function getCommandHandlers(commands) {
  const handlers = {};
  Object.keys(commands).forEach((cmdId) => {
    handlers[cmdId] = commands[cmdId].execute;
  });
  return handlers;
}
export function getCommandHotkeyHandlers(commands) {
  const handlers = {};
  Object.keys(commands).forEach((cmdId) => {
    const hotkey = commands[cmdId].hotkey;
    if (hotkey) {
      const combos = Array.isArray(hotkey) ? hotkey : [hotkey];
      combos.forEach((combo, i) => {
        const suffix = i === 0 ? "" : `_${i}`;
        handlers[`${cmdId}${suffix}`] = (event) => {
          if (!commands[cmdId].isDisabled && !commands[cmdId].isHidden) {
            commands[cmdId].execute({ event, viaHotkey: true });
          }
        };
      });
    }
  });
  return handlers;
}
